import { render, staticRenderFns } from "./middle-rank.vue?vue&type=template&id=dd89f238&"
import script from "./middle-rank.vue?vue&type=script&lang=ts&"
export * from "./middle-rank.vue?vue&type=script&lang=ts&"
import style0 from "./middle-rank.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports